module.exports = __webpack_public_path__ + "img/nonazis.05bcdd4b.png";